import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box } from '@mui/material';

import { formatDate } from '../../../../utils/formatDate';

export const DetailedTableBody = ({ data }) => {
  const tableCellStyle = { padding: '16px 8px' };
  const getColorStatus = (status) => {
    switch (status?.toLowerCase()) {
      case 'списание':
        return 'error.main';
      case 'начисление':
        return 'success.main';
      case 'отзыв бонусов':
        return 'warning.main';
      default:
        return 'primary.main';
    }
  };

  // минус должен быть при списании и отзыве, + при начислении
  const getAmountWithSignByStatus = (item) => {
    if (!item.amount) return 0;

    return item.addition ? `+${item.amount}` : `-${item.amount}`;
  };

  return (
    <TableBody>
      {data?.length ?
        <>
          {data?.map((item) => (
            <TableRow key={item.id} data-testid="Table">
              <TableCell sx={{ ...tableCellStyle }}>
                <Box
                  color={getColorStatus(item.status)}
                  data-testid={`status ${item.status}`}
                >
                  {item.status}
                </Box>
              </TableCell>
              <TableCell sx={{ padding: '16px 8px 16px 16px' }}>
                <Box>{item.document_number || '-'}</Box>
              </TableCell>
              <TableCell sx={{ ...tableCellStyle }}>{item.transaction_status}</TableCell>
              <TableCell sx={{ ...tableCellStyle }}>{item.customerAccountId || '-'}</TableCell>
              <TableCell sx={{ ...tableCellStyle }}>{item.branchId || '-'}</TableCell>
              <TableCell sx={{ ...tableCellStyle }}>{item.reason_name || '-'}</TableCell>
              <TableCell sx={{ ...tableCellStyle }}>{item.created_at ? formatDate(item.created_at, false) : '-'}</TableCell>
              <TableCell sx={{ ...tableCellStyle, width: '195px' }}>
                {item.company_name || '-'}
              </TableCell>
              <TableCell sx={{ ...tableCellStyle }} data-testid="Amount">{getAmountWithSignByStatus(item)}</TableCell>
              <TableCell sx={{ ...tableCellStyle }}>{item.date_expiry ? formatDate(item.date_expiry, true) : '-'}</TableCell>
            </TableRow>
          ))}
        </>
        : null
      }
    </TableBody>
  );
};

DetailedTableBody.propTypes = {
  data: PropTypes.array
};
